import { render, staticRenderFns } from "./CuerpoTecnicoCreateView.vue?vue&type=template&id=2d4f62ad&"
import script from "./CuerpoTecnicoCreateView.vue?vue&type=script&lang=js&"
export * from "./CuerpoTecnicoCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports